var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEndemic = function SvgEndemic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338,
    height: 358,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#endemic_svg__a)",
    d: "M168.848 54.715c-14.589 0-26.401 11.812-26.401 26.402s11.812 26.401 26.401 26.401 26.402-11.812 26.402-26.401-11.812-26.402-26.402-26.402"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#endemic_svg__b)",
    d: "M58.737 70.846c-5.672 0-10.27 4.599-10.27 10.271s4.598 10.271 10.27 10.271c5.673 0 10.271-4.598 10.271-10.27 0-5.673-4.598-10.272-10.27-10.272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#endemic_svg__c)",
    d: "M279.495 70.846c-5.672 0-10.271 4.599-10.271 10.271s4.599 10.271 10.271 10.271 10.271-4.598 10.271-10.27c0-5.673-4.598-10.272-10.271-10.272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#endemic_svg__d)",
    d: "M114.295 81.118c0-23.063 14.263-42.742 34.455-50.772L78.953 0h-1.937C34.81 0 .59 34.221.59 76.426c0 31.467 19.001 58.452 46.173 70.17l71.127-45.963a54.7 54.7 0 0 1-3.595-19.515m-55.464 26.401c-14.566 0-26.4-11.812-26.4-26.401s11.81-26.401 26.4-26.401 26.402 11.811 26.402 26.401-11.812 26.401-26.402 26.401"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#endemic_svg__e)",
    d: "M168.941 26.471c15.15 0 28.876 6.186 38.774 16.13L272.329.864A77 77 0 0 0 260.867 0H78.953l69.796 30.346a54.3 54.3 0 0 1 20.192-3.875"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#endemic_svg__f)",
    d: "M279.332 107.52c-14.567 0-26.402-11.811-26.402-26.401 0-1.797.187-3.572.537-5.276L219.876 61.23a54.5 54.5 0 0 1 3.735 19.866c0 30.182-24.463 54.646-54.646 54.646-23.297 0-43.185-14.589-51.052-35.131l-71.127 45.963c7.493 3.244 15.617 5.299 24.114 5.975 3.501.981 6.069 4.156 6.069 7.937v123.206c0 6.513 5.275 11.789 11.788 11.789s11.788-5.276 11.788-11.789v-89.731a8.288 8.288 0 0 1 16.574 0l-.046 5.882v114.429c0 6.513 5.275 11.788 11.788 11.788s11.788-5.275 11.788-11.788V187.098a8.29 8.29 0 0 1 8.287-8.287 8.29 8.29 0 0 1 8.287 8.287l-.047 6.279v152.338c0 6.513 5.276 11.789 11.789 11.789 6.512 0 11.788-5.276 11.788-11.789V193.377l-.047-10.411a8.29 8.29 0 0 1 8.287-8.287 8.29 8.29 0 0 1 8.287 8.287v109.69c0 6.513 5.276 11.788 11.788 11.788s11.789-5.275 11.789-11.788v-99.162c0-4.576 3.711-8.287 8.263-8.287s8.287 3.711 8.287 8.287l-.047 9.407v63.867c0 6.513 5.276 11.789 11.789 11.789s11.788-5.276 11.788-11.789V161.046a8.29 8.29 0 0 1 8.287-8.286h-7.446c30.136-.374 56.07-18.138 68.209-43.746l-29.179-12.675c-4.786 6.699-12.606 11.088-21.476 11.088z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#endemic_svg__g)",
    d: "m272.329.864-64.614 41.738a54.8 54.8 0 0 1 12.138 18.65l33.591 14.614c2.451-12.045 13.096-21.126 25.865-21.126 14.566 0 26.401 11.812 26.401 26.401 0 5.72-1.844 10.995-4.925 15.314l29.179 12.675a76.2 76.2 0 0 0 7.33-32.68c0-38.33-28.199-70.054-64.965-75.563z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "endemic_svg__a",
    x1: 168.849,
    x2: 168.849,
    y1: 61.088,
    y2: 92.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "endemic_svg__b",
    x1: 58.737,
    x2: 58.737,
    y1: 61.089,
    y2: 92.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "endemic_svg__c",
    x1: 279.495,
    x2: 279.495,
    y1: 61.089,
    y2: 92.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "endemic_svg__d",
    x1: 0.59,
    x2: 148.75,
    y1: 73.298,
    y2: 73.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "endemic_svg__e",
    x1: 78.953,
    x2: 272.329,
    y1: 21.312,
    y2: 21.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A79D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "endemic_svg__f",
    x1: 129.001,
    x2: 310.752,
    y1: 124.421,
    y2: 306.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E1F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "endemic_svg__g",
    x1: 261.708,
    x2: 355.104,
    y1: 36.136,
    y2: 129.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A29"
  })))));
};
export default SvgEndemic;